import { AdSize, adSizes } from '../../components/presentational/Ad';
import theme from '../../lib/theme';
const { mediaSizes } = theme;
const {
  video,
  mobileLeaderboard,
  mediumRectangle,
  largeLeaderboard,
  halfPage,
  leaderboard,
  smallBillboard,
  mediumBillboard,
  billboard,
  fluid,
  videoDesktop,
  videoMobile,
  shortBanner,
  mobileBanner,
  wideSkyScraper,
} = adSizes;

const HIDDEN_ADHESION = process.env.HIDDEN_ADHESION;

const sponsoredInarticle: AdSize = {
  sizeMapping: [
    {
      viewport: [leaderboard[0], 0],
      slot: [mediumBillboard],
    },
    { viewport: [0, 0], slot: [mediumRectangle] },
  ],
};

const standardInarticle: AdSize = {
  sizeMapping: [
    { viewport: [0, 0], slot: [fluid, mediumRectangle] },
    {
      viewport: [leaderboard[0], 0],
      slot: [],
    },
  ],
};

const siderail: AdSize = {
  sizeMapping: [
    { viewport: [0, 0], slot: [] },
    { viewport: [leaderboard[0], 0], slot: [halfPage, mediumRectangle] },
  ],
};

//#region Game Ad Sizes
const game_siderail: AdSize = {
  sizeMapping: [
    { viewport: [0, 0], slot: [] },
    { viewport: [mediaSizes.xl, 0], slot: [wideSkyScraper] },
    { viewport: [mediaSizes.xxl, 0], slot: [halfPage] },
  ],
};

const game_incontent: AdSize = {
  sizeMapping: [
    { viewport: [0, 0], slot: [fluid, mediumRectangle] },
    { viewport: [mediaSizes.xl, 0], slot: [], },
  ],
};

const game_top: AdSize = {
  sizeMapping: [
    { viewport: [0, 0], slot: [mobileBanner, mobileLeaderboard], },
    { viewport: [mediaSizes.s, 0], slot: [leaderboard] },
    { viewport: [mediaSizes.xl, 0], slot: [mediumBillboard, leaderboard], },
  ],
};

const game_billboard: AdSize = {
  sizeMapping: [
    { viewport: [0, 0], slot: [mobileBanner, mobileLeaderboard], },
    { viewport: [mediaSizes.s, 0], slot: [leaderboard] },
    { viewport: [mediaSizes.l, 0], slot: [mediumBillboard, leaderboard, billboard], },
  ],
};
//#endregion Game Ad Sizes

const adhesion: AdSize = {
  sizeMapping: [
    { viewport: [0, 0], slot: [mobileLeaderboard] },
    { viewport: [mediaSizes.m, 0], slot: [leaderboard] },
  ],
};

const billboardAd: AdSize = {
  sizeMapping: [
    {
      viewport: [0, 0],
      slot: [mediumRectangle],
    },
    {
      viewport: [mediaSizes.m, 0],
      slot: [mediumRectangle, leaderboard],
    },
    {
      viewport: [mediaSizes.l, 0],
      slot: [mediumRectangle, leaderboard, billboard],
    },
  ],
};

const config: { [key: string]: AdSize } = {
  standard_billboard: billboardAd,
  standard_comments: {
    sizeMapping: [
      {
        viewport: [0, 0],
        slot: [fluid, mediumRectangle],
      },
    ],
  },

  standard_inarticle_native: {
    sizeMapping: [
      {
        viewport: [0, 0],
        slot: [fluid],
      },
    ],
  },

  standard_recirculation_native1: {
    sizeMapping: [
      {
        viewport: [0, 0],
        slot: [fluid],
      },
    ],
  },

  standard_recirculation_native2: {
    sizeMapping: [
      {
        viewport: [0, 0],
        slot: [fluid],
      },
    ],
  },

  standard_inarticle_video: {
    sizeMapping: [
      {
        viewport: [0, 0],
        slot: [videoMobile, video],
      },
      {
        viewport: [1024, 0],
        slot: [videoDesktop, video],
      },
    ],
  },

  standard_high_impact: {
    sizeMapping: [
      {
        viewport: [0, 0],
        slot: [video],
      },
    ],
  },

  sticky_recirculation_native1: {
    sizeMapping: [
      {
        viewport: [0, 0],
        slot: [fluid],
      },
    ],
  },

  standard_inarticle1: standardInarticle,
  standard_inarticle2: standardInarticle,
  standard_siderail1: siderail,
  standard_siderail2: siderail,
  standard_adhesion: HIDDEN_ADHESION
    ? {
        sizeMapping: [
          {
            viewport: [0, 0],
            slot: [video],
          },
        ],
      }
    : adhesion,

  standard_scrollad: {
    sizeMapping: [
      {
        viewport: [1200, 0],
        slot: [ mediumBillboard, leaderboard, mediumRectangle ],
      },
      {
        viewport: [1024, 0],
        slot: [ mediumRectangle ],
      },
      {
        viewport: [800, 0],
        slot: [ mediumRectangle ],
      },
      {
        viewport: [0, 0],
        slot: [ video, halfPage, mediumRectangle ],
      },
    ],
  },

  sponsored_siderail1: siderail,
  sponsored_siderail2: siderail,
  sponsored_inarticle1: sponsoredInarticle,
  sponsored_inarticle2: sponsoredInarticle,
  sponsored_adhesion: adhesion,

  game_adhesion: adhesion,
  game_top: game_top,
  game_siderail1: game_siderail,
  game_siderail2: game_siderail,
  game_incontent1: game_incontent,
  game_incontent2: game_incontent,
  game_enterprise_billboard: game_billboard,
  game_recirculation_native1: billboardAd,
  game_recirculation_native2: billboardAd,
  game_billboard: {
    sizeMapping: [
      {
        viewport: [0, 0],
        slot: [leaderboard],
      },
      {
        viewport: [mediaSizes.m, 0],
        slot: [leaderboard],
      },
      {
        viewport: [mediaSizes.l, 0],
        slot: [leaderboard],
      },
    ],
  },
  
  standard_enterprise_billboard: billboardAd,
  standard_enterprise_inarticle_native: {
    sizeMapping: [
      {
        viewport: [0, 0],
        slot: [fluid],
      },
    ],
  },

  standard_enterprise_siderail_recirculation_native: {
    sizeMapping: [
      {
        viewport: [0, 0],
        slot: [fluid],
      },
    ],
  },

  sponsored_inarticle_native: {
    sizeMapping: [
      {
        viewport: [0, 0],
        slot: [fluid],
      },
    ],
  },

  sponsored_inbetween: {
    sizeMapping: [
      {
        viewport: [0, 0],
        slot: [fluid, mediumRectangle],
      },
      {
        viewport: [mediaSizes.m, 0],
        slot: [fluid, mediumRectangle, mediumBillboard, leaderboard],
      },
      {
        viewport: [mediaSizes.l, 0],
        slot: [fluid, mediumRectangle, mediumBillboard, billboard],
      },
    ],
  },
};

export default config;
